// extracted by mini-css-extract-plugin
module.exports = {"tutorial":"styles_tutorial__1BYUL","btnTutorial":"styles_btnTutorial__3sSqm","icon":"styles_icon__GLuap","browsers":"styles_browsers__34tEz"};